import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('inheritance')
export class Inheritance {
  @JsonProperty('id', String, true)
  public id?: string = undefined;

  @JsonProperty('gender', String, true)
  public gender = '';

  @JsonProperty('name', String, true)
  public name: string | null = null;

  @JsonProperty('firstname', String, true)
  public firstname = '';

  @JsonProperty('address', String, true)
  public address = '';

  @JsonProperty('completaryAddress', String, true)
  public complementaryAddress = '';

  @JsonProperty('zipcode', String, true)
  public zipcode = '';

  @JsonProperty('city', String, true)
  public city = '';

  @JsonProperty('country', String, true)
  public country = '';

  @JsonProperty('email', String, true)
  public email = '';

  @JsonProperty('phoneNumber', String, true)
  public phoneNumber = '';

  @JsonProperty('relationshipWithDeceased', String, true)
  public relationshipWithDeceased = '';
}

@JsonObject('inheritanceInformations')
export class InheritanceInformation {
  @JsonProperty('children', [Inheritance], true)
  public children: Inheritance[] = [];

  @JsonProperty('hasChild', String, true)
  public hasChild: string | null = null;

  @JsonProperty('hasSpouse', Boolean, true)
  public hasSpouse = false;

  @JsonProperty('readOnlySpouse', Boolean, true)
  public readOnlySpouse = false;

  @JsonProperty('readOnlyFirstChild', Boolean, true)
  public readOnlyFirstChild = false;

  @JsonProperty('showSpouse', Boolean, true)
  public showSpouse = false;

  @JsonProperty('spouse', Inheritance, true)
  public spouse?: Inheritance = undefined;
}
